import { TrackedAnchor } from '@/components/ancher';

interface FaqItemProps {
  question: string;
  link: string;
  id: string;
}

export default function FaqItem({ question, link, id }: FaqItemProps) {
  return (
    <li className="border-b border-solid border-b-[#E4E6EB] first:border-t first:border-t-[#E4E6EB]">
      <TrackedAnchor
        href={link}
        className="flex cursor-pointer items-center gap-10 self-stretch px-0 py-4 text-[#BEC2CC] hover:text-[#040435] hover:underline md:px-2.5 md:py-5"
        prefetch={false}
        label={`faq_item-${id}`}
        position="main_content"
      >
        <div className="flex-[1_0_0] text-base font-medium leading-6 tracking-[-0.176px] text-[#2B2E33] md:text-lg md:leading-7 md:tracking-[-0.256px]">
          {question}
        </div>
        <RightArrow />
      </TrackedAnchor>
    </li>
  );
}

function RightArrow() {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      xmlns="http://www.w3.org/2000/svg"
      className="fill-current"
    >
      <rect y="0.5" width="40" height="40" rx="20" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5632 27.02C16.7585 27.2152 17.075 27.2152 17.2703 27.02L23.4367 20.8536C23.632 20.6583 23.632 20.3417 23.4367 20.1465L17.2703 13.9801C17.075 13.7848 16.7585 13.7848 16.5632 13.9801C16.3679 14.1753 16.3679 14.4919 16.5632 14.6872L22.376 20.5L16.5632 26.3129C16.3679 26.5081 16.3679 26.8247 16.5632 27.02Z"
        fill="currentcolor"
      />
      <path
        d="M17.2703 27.02L16.9167 26.6664H16.9167L17.2703 27.02ZM16.5632 27.02L16.9167 26.6664L16.5632 27.02ZM23.4367 20.8536L23.0831 20.5L23.4367 20.8536ZM23.4367 20.1465L23.0831 20.5L23.4367 20.1465ZM17.2703 13.9801L17.6239 13.6265L17.6239 13.6265L17.2703 13.9801ZM16.5632 13.9801L16.2096 13.6265L16.2096 13.6265L16.5632 13.9801ZM16.5632 14.6872L16.9168 14.3336L16.9168 14.3336L16.5632 14.6872ZM22.376 20.5L22.7296 20.8536L23.0831 20.5L22.7296 20.1465L22.376 20.5ZM16.5632 26.3129L16.9167 26.6664L16.5632 26.3129ZM16.9167 26.6664H16.9167L16.2096 27.3735C16.6002 27.764 17.2333 27.764 17.6239 27.3735L16.9167 26.6664ZM23.0831 20.5L16.9167 26.6664L17.6239 27.3735L23.7902 21.2071L23.0831 20.5ZM23.0831 20.5L23.7902 21.2071C24.1808 20.8166 24.1808 20.1834 23.7902 19.7929L23.0831 20.5ZM16.9168 14.3336L23.0831 20.5L23.7902 19.7929L17.6239 13.6265L16.9168 14.3336ZM16.9168 14.3336L16.9168 14.3336L17.6239 13.6265C17.2333 13.236 16.6002 13.236 16.2096 13.6265L16.9168 14.3336ZM16.9168 14.3336L16.9168 14.3336L16.2096 13.6265C15.8191 14.017 15.8191 14.6502 16.2096 15.0407L16.9168 14.3336ZM22.7296 20.1465L16.9168 14.3336L16.2096 15.0407L22.0225 20.8536L22.7296 20.1465ZM16.9167 26.6664L22.7296 20.8536L22.0225 20.1465L16.2096 25.9593L16.9167 26.6664ZM16.9167 26.6664L16.2096 25.9593C15.8191 26.3498 15.8191 26.983 16.2096 27.3735L16.9167 26.6664Z"
        fill="currentColor"
      />
    </svg>
  );
}
